import { render, staticRenderFns } from "./FieldReply.vue?vue&type=template&id=24fefc2a&scoped=true"
import script from "./FieldReply.vue?vue&type=script&lang=js"
export * from "./FieldReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fefc2a",
  null
  
)

export default component.exports